module.exports = __webpack_public_path__ + "img/calendar.83e6dfa1.svg";